import type React from "react";
import { Line as VLine } from "@visx/shape";
import type { Margin, ScaleLinear } from "types/charts";
import useAreaChart from "../AreaChartProvider/useAreaChartStore/useAreaChartStore";
import useYAxisActions from "../YAxisProvider/useYAxisActions";

type VLineProps = Omit<typeof VLine extends (props: infer P) => any ? P : never, "from" | "to">;

export interface RenderLineProps {
  scale: ScaleLinear;
  margin: Margin;
  width: number;
  height: number;
}

export interface ReferenceLineProps extends VLineProps {
  yAxisId?: string;
  value?: number;
  renderLine?: (props: RenderLineProps) => React.ReactNode;
}

function ReferenceLine(props: ReferenceLineProps) {
  const { margin, width, height } = useAreaChart();
  const { getYScale } = useYAxisActions();

  const y = getYScale(props.yAxisId);

  if (props.renderLine) {
    return <>{props.renderLine({ scale: y, margin, width, height })}</>;
  }

  if (!y || !props.value) {
    return null;
  }

  return (
    <VLine
      from={{ x: margin.left, y: y(props.value) }}
      to={{ x: width - margin.right, y: y(props.value) }}
      strokeDasharray="4,2"
      strokeWidth={1.5}
      {...props}
    />
  );
}

export default ReferenceLine;
